import { IEmptyImage } from "./IEmptyImage";

export default function EmptyImage({ image, icon }: IEmptyImage) {
    return (
        <div style={{
            borderRadius: '5px',
            background: '#F5F6FA',
            height: '8svh',//'100%',
            width: '8svh',//'50%',
            justifyContent: "center",
            display: "flex",
            alignItems: 'center',
        }}>
            {image ? <img
                style={{ margin: "0 auto" }}
                className="text-center block"
                src={image}
            /> : icon ? icon : <></>}
        </div>
    )
}